import React from 'react';

import './Styles.scss';
import './styles.css';

export default function Br() {
  return (
    <div className="privacy-page">
      <h2>Política de Privacidade da BASF</h2>

      <p>
        Na BASF, proteção de dados têm prioridade. Esta página é projetada para
        fornecer informações sobre como estamos seguindo as normas de proteção
        de dados, quais informações coletamos enquanto você está navegando em
        nosso site/app, e como essas informações são coletadas, utilizadas e
        protegidas por nós, em conformidade com a Lei nº 13.709/2018 (Lei Geral
        de Proteção de Dados – “LGPD”).
        <br />
        <br /> Primeiro e mais importante: os seus dados pessoais só serão
        utilizados nos casos detalhados abaixo e não serão utilizados em
        quaisquer outros casos sem o seu consentimento expresso.
        <br />
        <br /> Esta Política de Privacidade de Dados aplica-se a coleta e o
        tratamento de dados somente para as seguintes plataformas/frentes de
        comunicação: e-mails marketing, mídias sociais (Facebook, LinkedIn e
        YouTube), aplicativo para aparelhos de celular, website corporativo, e
        WhatsApp (recebimento de conteúdos e informações sobre a marca).
      </p>

      <h2>Coleta de dados</h2>
      <p>
        Após autenticação do usuário, o aplicativo armazena a data e horário do
        acesso, informações associadas ao cadastro do usuário.{' '}
      </p>

      <h2>Coleta e processamento de dados pessoais</h2>
      <p>
        Dados pessoais só são coletados quando você os fornecer no curso, por
        exemplo, de seu cadastro em nosso site/app, do preenchimento de
        formulários ou envio de e-mails, ou por meio de encomendas de produtos
        ou serviços, consultas ou pedidos de material.
        <br />
        <br />
        Informamos que para o uso do aplicativo, é necessário coletar os
        seguintes dados pessoais: nome, celular e e-mail dos usuários. O celular
        é necessário para o processo de dupla autenticação do app. O e-mail é
        necessário para o envio de requisição de cotação de produtos e o app
        armazena o histórico de pedidos. São armazenados também os dados de
        conexão entre o usuário e o equipamento multiscent, caso ele possua um
        equipamento. No caso de posse do equipamento também são armazenados os
        dados de experimentação de cada produto.
        <br />
        <br />
        Seus dados pessoais permanecem com a nossa empresa, nossas afiliadas, e
        nosso provedor, e poderão ser compartilhados pela BASF somente com seus
        fornecedores/prestadores de serviços que necessitem ter acesso a tais
        dados para o cumprimento de suas obrigações junto à BASF. Nesta
        hipótese, tais fornecedores/prestadores de serviços somente poderão
        utilizar seus dados pessoais de acordo com as nossas instruções e as
        finalidades previstas abaixo nesta Política, e encontram-se
        contratualmente obrigados a cumprir com os requisitos legais de proteção
        de dados aplicáveis.
        <br />
        <br />
        Os dados pessoais que nós coletamos somente serão utilizados a fim de
        cumprir as nossas obrigações junto a você e mantê-lo informado a
        respeito de eventos, conteúdos técnicos/estudos, produtos, serviços,
        pesquisas de opinião sobre os produtos e serviços e/ou outras
        informações da BASF, conforme seu perfil, por meio de e-mails marketing.
        A BASF poderá ainda utilizar os dados coletados para o desenvolvimento
        de estudos, pesquisas e análises internas de marketing, realizados para
        melhorar nossas ações. Além disso, para garantia de qualidade, bem como
        por questões legais, de segurança e treinamentos, poderemos monitorar,
        gravar e arquivar chamadas, conversas em chats e demais comunicações.
        <br />
        <br />
        Importante: seus dados pessoais apenas serão utilizados para qualquer
        outra finalidade quando você tiver dado seu consentimento específico
        para tanto. Você pode revogar o seu consentimento para a utilização dos
        seus dados pessoais a qualquer momento, basta enviar um e-mail para{' '}
        <a href="mailto:data-protection.br@basf.com">
          data-protection.br@basf.com
        </a>
        solicitando a revogação do seu consentimento ao endereço de e-mail do
        Encarregado de Dados, informado ao final desta Política Por favor note
        que esta revogação de consentimento poderá impactar a disponibilidade de
        certos serviços e programas, bem como seu acesso a informações sobre a
        BASF, que são compartilhadas via canais digitais, como e-mails marketing
        enviados com base em seus interesses.
        <br />
        <br />
        Mesmo após o término da relação contratual, nós poderemos tratar alguns
        de seus dados pessoais para exercer nossos direitos garantidos em lei,
        inclusive como prova em processos judiciais, administrativos ou
        arbitrais, principalmente àqueles relacionados com regularização de
        sinistros envolvendo você e/ou terceiros.
      </p>

      <h2>Retenção de dados</h2>
      <p>
        Nós armazenamos dados pessoais pelo período necessário para realizar um
        serviço que você tenha solicitado ou para o cumprimento das finalidades
        com as quais você tenha concedido sua permissão, desde que não existam
        requisitos legais contrários, como por exemplo no caso de períodos de
        retenção exigidos pelo comércio ou normas tributárias.
      </p>

      <h2>Segurança</h2>
      <p>
        A BASF possui medidas de segurança técnicas e organizacionais para
        prevenir que a informação que você disponibilizou seja manipulada,
        intencionalmente ou não, perdida, destruída ou acessada por pessoas não
        autorizadas. Quando os dados pessoais estão sendo coletados e
        processados, as informações serão transferidas de forma criptografada, a
        fim de evitar o uso indevido dos dados por terceiros. Nossas medidas de
        segurança são continuamente analisadas e revistas, de acordo com a
        tecnologia adequada.
        <br />
        <br />
        Embora a BASF adote os melhores esforços no sentido de preservar a sua
        privacidade e proteger os seus dados pessoais, nenhuma transmissão de
        informações é totalmente segura, de modo que a BASF não pode garantir
        integralmente que todas as informações que recebe e/ou envia não sejam
        alvo de acessos não autorizados perpetrados por meio de métodos
        desenvolvidos para obter informações de forma indevida, como falhas
        técnicas, vírus ou invasões do banco de dados do site.
        <br />
        <br />
        De qualquer forma, na remota hipótese de incidência de episódios desta
        natureza, a BASF garante seus melhores esforços para remediar as
        consequências do evento. A BASF não se responsabiliza por qualquer outro
        site que possa ser acessado a partir do nosso, não havendo qualquer
        vínculo entre tais endereços.
      </p>

      <h2>Direito de obter e corrigir informações</h2>
      <p>
        Você tem o direito de obter informações sobre todos os seus dados
        pessoais armazenados, poderá recebê-los, examiná-los e, se necessário,
        alterá-los ou apagá-los. Para fazer isso, basta enviar um e-mail ao
        endereço de e-mail do Encarregado, informado ao final desta Política. A
        eliminação dos seus dados pessoais será realizada, a menos que sejamos
        obrigados por lei a armazenar tais informações (conforme item de
        “Retenção de Dados” acima).
        <br />
        <br />A BASF imputará seus melhores esforços para atender os pedidos de
        Usuários no menor espaço de tempo possível. No caso de requisição de
        exclusão, será respeitado o prazo de armazenamento mínimo de informações
        de usuários de aplicações de Internet, determinado pela legislação
        brasileira, além de outras leis aplicáveis como a legislação trabalhista
        e tributária.
      </p>

      <h2>Cookies</h2>
      <p>
        Cookies são pequenos arquivos de texto compartilhados entre o seu
        navegador web e nosso site, e que ficam armazenadas no navegador do
        dispositivo do visualizador para um site visitado (servidor web,
        servidor). O cookie é enviado do servidor web para o navegador ou gerado
        no navegador por um script (JavaScript). O servidor web pode ler essas
        informações de cookies diretamente do servidor quando o usuário visitar
        esta página novamente ou transferir as informações de cookies para o
        servidor através de um script do site. Os cookies não causam nenhum dano
        ao seu dispositivo, não contêm vírus, trojans ou outros malwares.
        <br />
        <br />
        As informações são armazenadas no cookie relacionado ao dispositivo
        específico utilizado. Isso não significa, no entanto, que obtenhamos
        conhecimento direto de sua identidade.
        <br />
        <br />
        Em linhas gerais podemos utilizar cookies para que possamos lhe
        proporcionar uma melhor experiência em todos os aspectos quando da
        navegação em nossa plataforma.
      </p>

      <h2>Legislação Aplicável e Foro</h2>
      <p>
        Esta Política será interpretada de acordo com as leis, normas e
        regulamentos do Brasil, no idioma português, especialmente de acordo com
        a Lei nº 13.709/2018 (Lei Geral de Proteção de Dados). Quaisquer
        conflitos serão dirimidos em território nacional e conforme a legislação
        brasileira aplicável e vigente à época.
      </p>

      <h2>Contato - Encarregado de Dados</h2>
      <p>
        O desenvolvimento constante da Internet nos traz a necessidade de
        ajustarmos periodicamente nossas regras de proteção de dados.
        Reservamo-nos o direito de implantar as mudanças adequadas a qualquer
        momento. Caso tenha alguma dúvida ou sugestão, entre em contato com o
        representante de proteção aos dados na BASF, que terá o maior prazer em
        ajudá-lo. O nosso Encarregado de Dados é:
      </p>
      <br />
      <br />
      <h6>
        Andre de Oliveira
        <br />
        Data Protection Officer - Brasil
        <br />
        e-mail:
        <a href="mailto:data-protection.br@basf.com">
          data-protection.br@basf.com
        </a>
      </h6>
    </div>
  );
}
